'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { removeSourceUrl } from '../../utils/removeSourceUrl.js';
import { useSettings } from '../provider/index.js';
import { RawLink } from './Link.js';
const DefaultItemWrapper = ({ className, children }) => (_jsx("li", { className: className, children: children }));
const DefaultMenuWrapper = ({ className, children }) => (_jsx("ul", { className: className, children: children }));
const DefaultLinkWrapper = ({ href, children }) => {
    const settings = useSettings();
    const LinkComponent = typeof settings.linkComponent === 'function' ? settings.linkComponent : RawLink;
    return _jsx(LinkComponent, { href: href, children: children });
};
export const MenuItems = ({ items, depth, topLevelItemsClickable, itemWrapper: ItemWrapper, menuWrapper: MenuWrapper, linkWrapper: LinkWrapper, }) => {
    const settings = useSettings();
    return (_jsx(_Fragment, { children: items.map((item) => {
            const link = removeSourceUrl({
                link: item.url,
                backendUrl: settings.sourceUrl || '',
            });
            const shouldLink = item.children.length === 0 || topLevelItemsClickable;
            let classNames = [`menu-item-depth-${depth}`];
            if (item.children.length) {
                classNames = [...classNames, 'menu-item-has-children'];
            }
            if (item.classes.length) {
                classNames = [...classNames, ...item.classes];
            }
            return (_jsxs(ItemWrapper, { className: classNames.join(' '), depth: depth, item: item, children: [shouldLink ? (_jsx(LinkWrapper, { href: link, depth: depth, children: item.title })) : (item.title), item.children.length > 0 && (_jsx(Menu, { items: item.children, depth: depth + 1, menuWrapper: MenuWrapper, itemWrapper: ItemWrapper, linkWrapper: LinkWrapper }))] }, item.ID));
        }) }));
};
export function Menu({ items, className = 'menu-container', depth = 0, topLevelItemsClickable = false, itemWrapper = DefaultItemWrapper, menuWrapper = DefaultMenuWrapper, linkWrapper = DefaultLinkWrapper, }) {
    const classes = [className, `menu-depth-${depth}`];
    const MenuWrapper = menuWrapper;
    return (_jsx(MenuWrapper, { className: classes.join(' '), depth: depth, children: _jsx(MenuItems, { items: items, depth: depth, topLevelItemsClickable: topLevelItemsClickable, menuWrapper: menuWrapper, itemWrapper: itemWrapper, linkWrapper: linkWrapper }) }));
}
